import React from 'react';
import { motion } from 'framer-motion';

export const Privacy = () => {
  return (
    <div className="min-h-screen bg-[#050505] pt-32 pb-24" data-testid="privacy-page">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-[#D4AF37] text-sm uppercase tracking-[0.3em]">Legal</span>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white mt-4 mb-6">
            Privacy <span className="italic text-[#D4AF37]">Policy</span>
          </h1>
          <p className="text-white/50 text-sm mb-16">Effective date: January 1, 2026</p>

          <div className="space-y-10 text-white/75 leading-relaxed">
            <section>
              <p>
                White Glove Event Concierge (&ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;) respects your privacy and is committed to protecting the personal information you share with us. This Privacy Policy explains how we collect, use, and safeguard information when you visit our website or engage with our services.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-white mb-4">Information We Collect</h2>
              <p className="mb-3">We may collect the following types of information:</p>
              <ul className="space-y-2 list-disc list-inside text-white/70">
                <li><strong className="text-white">Contact information</strong> you provide, such as your name, email address, phone number, and event details submitted through our inquiry form.</li>
                <li><strong className="text-white">Account information</strong> if you create a client portal account, including login credentials and event preferences.</li>
                <li><strong className="text-white">Communications</strong> you exchange with us, including emails, messages, and notes captured during consultations.</li>
                <li><strong className="text-white">Usage data</strong> such as IP address, browser type, pages visited, and referral source, collected automatically through cookies and standard web analytics.</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-white mb-4">How We Use Your Information</h2>
              <p className="mb-3">We use the information we collect to:</p>
              <ul className="space-y-2 list-disc list-inside text-white/70">
                <li>Respond to inquiries and schedule consultations.</li>
                <li>Deliver services, share vendor recommendations, and coordinate with trusted partners on your behalf.</li>
                <li>Improve our website, offerings, and client experience.</li>
                <li>Send relevant updates, proposals, or service communications you&apos;ve requested.</li>
                <li>Comply with legal obligations and protect the rights of our clients and business.</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-white mb-4">How We Share Information</h2>
              <p>
                We do not sell or rent your personal information. We may share necessary details with trusted third parties who support our operations (such as payment processors, CRM tools like HubSpot, and email providers like Resend) and with vendors involved in your event — only to the extent required to deliver the services you&apos;ve engaged us for. All such partners are required to maintain confidentiality and handle your information responsibly.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-white mb-4">Data Retention & Security</h2>
              <p>
                We retain your information for as long as necessary to provide our services and fulfill legitimate business or legal purposes. Reasonable technical and administrative safeguards are in place to protect your data against unauthorized access. However, no system is entirely impenetrable, and we cannot guarantee absolute security.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-white mb-4">Your Rights</h2>
              <p>
                You may request access to, correction of, or deletion of personal information we hold about you. You may also opt out of non-essential communications at any time. To exercise these rights, contact us at <a href="mailto:info@whitegloveeventconcierge.com" className="text-[#D4AF37] hover:underline">info@whitegloveeventconcierge.com</a>.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-white mb-4">Cookies</h2>
              <p>
                Our site uses cookies and similar technologies to improve functionality and measure site performance. You can adjust your browser settings to refuse cookies, though certain features of the site may not function properly as a result.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-white mb-4">Changes to This Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. When we do, we&apos;ll revise the &ldquo;Effective date&rdquo; above. Continued use of our site or services after changes constitutes acceptance of the revised policy.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-white mb-4">Contact</h2>
              <p>
                Questions about this Privacy Policy? Reach us at <a href="mailto:info@whitegloveeventconcierge.com" className="text-[#D4AF37] hover:underline">info@whitegloveeventconcierge.com</a>.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};
